module.exports = __webpack_public_path__ + "assets/44f5b70d6a484838865b3ed78152f8de.jpg";